import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-component-error-eqrcode',
    templateUrl: './error-eqrcode.component.html',
    styleUrls: ['./error-eqrcode.component.css']
})

export class ErrorEqrcodeComponent implements OnInit {
    isMobile = window.innerWidth < 1000 ? true : false;

    constructor(private router : Router) { }
    ngOnInit() {}

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }
}